import { AvailableCurrencies } from 'utils/clickme';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { InvoicePayerType } from 'store/models/invoices';

type PayerId = string;

export enum PayerAgreementType {
    Offer = 'OFFER',
    Uniform = 'UNIFORM',
    Bilateral = 'BILATERAL',
}

export interface Account {
    id: number | null;
    title: string | null;
    main: boolean;
    currency: AvailableCurrencies;
}

interface BillingDetails {
    payer: InvoicePayerType;
    title: string;
    inn: string;
    kpp: string;
    address: string;
    post: string;
}

interface Agreement {
    number: string;
    createdAt: string;
}

interface Payer {
    hhPayerId: number;
    hhPayerName: string;
    agreementId: string;
    agreementType: PayerAgreementType;
    agreementStartDate: string;
}

export interface PayerDetail {
    employerId: number;
    hhid: number;
    userId: number;
    accounts: Account[];
    payerId: number;
    email: string;
    userName: string;
    billingDetails: BillingDetails;
    hhPayerId: string;
    agreement: Agreement;
    payers: Payer[];
    dateLastUpdate: string;
    activePayer: boolean;
}

// ----------------------- actions -------------------------------------
const SET_PAYER_PAYER_DETAIL = 'SET_PAYER_PAYER_DETAIL';
const SET_PAYER_ID_PAYER_DETAIL = 'SET_PAYER_ID_PAYER_DETAIL';

interface PayloadTypes {
    [SET_PAYER_PAYER_DETAIL]: Partial<PayerDetail>;
    [SET_PAYER_ID_PAYER_DETAIL]: PayerId;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setPayer = ActionCreator(SET_PAYER_PAYER_DETAIL);
export const setPayerId = ActionCreator(SET_PAYER_ID_PAYER_DETAIL);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface PayerDetailState {
    payer: Partial<PayerDetail>;
    payerId: PayerId;
}

const PAYER_DETAIL_INITIAL_STATE = {
    payer: {},
    payerId: '',
};

export default createReducer<PayerDetailState, PayloadTypes>(PAYER_DETAIL_INITIAL_STATE, {
    [SET_PAYER_PAYER_DETAIL]: (state, { payload }) => ({
        ...state,
        payer: payload,
    }),
    [SET_PAYER_ID_PAYER_DETAIL]: (state, { payload }) => ({
        ...state,
        payerId: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
